export const randomRange = (min: number, max: number) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const random = <T>(list: T[]) => {
	return list[Math.floor(Math.random() * list.length)];
};
